import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/portal/organisation/settings")({
  beforeLoad: () => {
    throw redirect({ to: "/portal/platform/settings" });
  },
});
